export const loadFiltersOptions = ({
    courseStatusEnum,
    userStatusEnum,
    sites,
    participationEnum,
    trainingFields,
    departments,
    roles,
    levels
}) => {
    const courseStatus = [{
        label: courseStatusEnum.LABELS.COMPLETED,
        value: courseStatusEnum.KEYS.PASSED
    }, {
        label: courseStatusEnum.LABELS.NOT_COMPLETED,
        value: courseStatusEnum.KEYS.NOT_PASSED
    }, {
        label: courseStatusEnum.LABELS.NOT_STARTED,
        value: courseStatusEnum.KEYS.NOT_STARTED
    }, {
        label: courseStatusEnum.LABELS.IN_PROGRESS,
        value: courseStatusEnum.KEYS.IN_PROGRESS
    }];

    const userStatusOptions = {};
    Object.keys(userStatusEnum.KEYS).forEach(key => {
        userStatusOptions[key] = {
            label: userStatusEnum.LABELS[key],
            value: userStatusEnum.KEYS[key]
        };
    });

    const siteOptions = {};
    sites.forEach(({ id, name }) => {
        siteOptions[id] = {
            label: name,
            value: id
        };
    });

    const departmentOptions = {};
    departments.forEach((option) => {
        departmentOptions[option.id] = option;
    });

    const roleOptions = {};
    roles.forEach((option) => {
        roleOptions[option.id] = option;
    });

    const levelOptions = {};
    levels.forEach((option) => {
        levelOptions[option.id] = option;
    });

    const participationOptions = {};

    Object.keys(participationEnum.KEYS).forEach(key => {
        participationOptions[key] = {
            label: participationEnum.LABELS[key],
            value: participationEnum.KEYS[key]
        };
    });

    const trainingFieldOptions = {};
    [...trainingFields].sort((a, b) => a.value.localeCompare(b.value)).forEach(({ id, value }) => {
        trainingFieldOptions[id] = {
            label: value,
            value: id
        };
    });

    return {
        courseStatus,
        userStatusOptions,
        siteOptions,
        departmentOptions,
        roleOptions,
        levelOptions,
        participationOptions,
        trainingFieldOptions
    };
};



// WEBPACK FOOTER //
// ./src/app/components/reports/courseresults/learnerProgress/filter/helpers.js